export const common = {
  actions: {
    back: 'Terug',
    bookmark: 'Bewaren',
    cancel: 'Annuleren',
    clear: 'Wissen',
    close: 'Sluiten',
    copiedToClipboard: 'Gekopieerd naar klembord',
    copyToClipboard: 'Kopiëren naar klembord',
    create: 'Aanmaken',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    moreInfo: 'Meer informatie',
    openMenu: 'Menu openen',
    retry: 'Opnieuw proberen',
    revealPassword: 'Wachtwoord tonen',
    save: 'Opslaan',
    send: 'Versturen',
  },
  activities: {
    '1': {
      description: 'Grafisch ontwerp, Illustratie, Cartoon, Industrieel Design, Brand Design, Art Direction, 3D Art, …',
      label: 'Visuele communicatie',
    },
    '10': {
      description: 'Social media',
      label: 'Online contentcreatie en storytelling',
    },
    '11': {
      label: 'Andere',
    },
    '2': {
      description: 'Webdesign, UI/UX, …',
      label: 'Digitaal ontwerp',
    },
    '3': {
      description: 'Fotografie, postproductie, …',
      label: 'Fotografie',
    },
    '4': {
      description: 'Videografie, Montage, Voice-over, Motion design, Sound design, …',
      label: 'Audiovisueel',
    },
    '5': {
      description: 'Copywriting, Vertaling, Redactie, …',
      label: 'Taal en communicatie',
    },
    '6': {
      description: 'IT-development, Web-development, Game-development, …',
      label: 'IT-ontwikkeling',
    },
    '7': {
      description: 'Cursus, Workshop, …',
      label: 'Opleiding',
    },
    '8': {
      description: 'Model, Presentator, Acteur, …',
      label: 'Uitvoerende kunstenaar',
    },
    '9': {
      description: 'Styling, Foodstyling, Interieurontwerp, …',
      label: 'Styling & interieur',
    },
  },
  add: 'Toevoegen',
  autoSave: 'Opslaan…',
  autoSaveLastSavedAt: {
    justNow: 'Net opgeslagen',
    timeAgo: '{{timeAgo}} opgeslagen',
  },
  blocker: {
    leave: 'Verlaten zonder opslaan',
    stay: 'Blijf op pagina',
    title: 'Pagina verlaten',
  },
  breadcrumb: 'Breadcrumb',
  breadcrumbs: {
    details: 'Details',
    draft: 'Concept',
    home: 'Home',
  },
  colorPicker: {
    ariaLabel: 'Verander het kleurenthema. {{ colorTheme }} is actief.',
    options: {
      'blue-orange': 'Blauw-oranje',
      'bordeaux-gray': 'Bordeaux-grijs',
      'green-pink': 'Groen-roze',
      'purple-yellow': 'Paars-geel',
      'red-lightblue': 'Rood-lichtblauw',
    },
  },
  combobox: {
    removeChip: 'Verwijder {{label}}',
  },
  customAgreementOptionLabel: 'Volgens raamovereenkomst',
  datatable: {
    all: 'alles',
    deleteFilter: '{{filter}}-filter verwijderen',
    download: 'Downloaden',
    filters: 'Filters',
    loadingData: 'Gegevens aan het laden…',
    noData: 'Geen resultaten gevonden.',
    search: 'Zoeken',
    selection: {
      amountSelected: '{{amount}} geselecteerd.',
      removeSelection: 'Selectie verwijderen',
      selectAll: 'Alles selecteren',
      selectRow: 'Selecteer rij',
    },
    show: 'Toon',
    showFilters: 'Toon filters',
    showResults: 'Toon resultaten',
    sortBy: 'Sorteer op {{column}}',
  },
  draft: {
    defaultTitle: 'Geen titel',
    deleteModal: {
      description: 'Ben je zeker dat je het concept wilt verwijderen?',
      submit: 'Verwijder concept',
      title: 'Concept verwijderen',
    },
  },
  error: 'Er ging iets mis. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
  errors: {
    contactSupport:
      'Neem contact op met <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het probleem zich blijft voordoen.',
    fetchError: 'Geen verbinding met de server. Controleer je verbinding en probeer het nog eens.',
    global: {
      text: 'Mail naar <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email>, vertel waar het misloopt. Zij helpen je verder.',
      title: 'Het ging even mis',
    },
    httpErrorWithLink:
      'Er ging iets mis. Neem contact op met <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> als het probleem zich blijft voordoen.',
    tooManyRequests: 'Overload! Te vaak geprobeerd. Wacht je even en probeer je het dan nog eens?',
    unknown: 'Er is een onverwachte fout opgetreden.',
  },
  export: 'Exporteren',
  fields: {
    datePicker: {
      label: 'Datum',
      openCalendar: 'Open kalender',
    },
    numberInput: {
      decrement: 'Waarde verlagen',
      increment: 'Waarde verhogen',
    },
    prefixAriaLabel: 'Dit veld heeft een prefix "{{prefix}}". Dit hoef je zelf niet in te vullen.',
    select: {
      multipleValuesAriaLabel: '{{ count }} items geselecteerd',
    },
    suffixAriaLabel: 'Dit veld heeft een suffix "{{suffix}}". Dit hoef je zelf niet in te vullen.',
  },
  fileUpload: {
    avatarPrompt: '<browse>Klik om een foto te kiezen</browse> of sleep je foto hierin',
    dropTarget: 'Zet je bestanden hier neer',
    error: 'Bestand uploaden mislukt.',
    filePrompt: '<browse>Klik om een bestand toe te voegen</browse> of sleep je bestand hierin',
    maxSize: 'max {{max}} MB',
    rejectedSize: '{{name}} is groter dan {{max}} MB.',
    rejectedType: '{{name}} heeft een bestandstype dat niet wordt ondersteund.',
    remove: 'Bestand verwijderen',
    retry: 'Opnieuw proberen',
    unnamedFile: 'Bestand',
    uploading: 'Uploaden',
    view: 'Bestand bekijken',
  },
  greetings: {
    common: 'Hi',
    evening: 'Goedenavond',
    morning: 'Goedemorgen',
    noon: 'Goedemiddag',
  },
  impersonationBanner: {
    description: 'Acties die je hier uitvoert worden geregistreerd alsof deze gebruiker ze zelf doet.',
    stop: 'Stop impersonatie',
    title: 'Je bekijkt het account van {{name}}',
  },
  infiniteScroll: {
    scrollToTop: 'Terug naar boven',
    showMore: 'Meer tonen',
  },
  languageSelector: 'Open taalkiezer, {{value}} is geselecteerd',
  languages: {
    en: 'Engels',
    fr: 'Frans',
    nl: 'Nederlands',
  },
  languagesShort: {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
  },
  listbox: {
    noOptions: 'Geen resultaten',
    noResults: 'Geen resultaten',
    search: 'Zoeken…',
  },
  loading: 'Gegevens aan het laden…',
  maintenance: {
    description: 'We zijn even aan het werk in het platform, maar zijn snel terug zodat je ons niet te lang hoeft te missen.',
    title: 'Heel even weg, maar snel terug!',
  },
  menu: {
    documents: 'Documenten',
    invitations: 'Uitnodigingen',
    logout: 'Uitloggen',
    pricing: 'Je vergoeding',
    settings: 'Instellingen',
  },
  models: {
    quotation: 'Offerte',
  },
  navigation: {
    main: 'Hoofdnavigatie',
    menu: 'Menu',
    shortcuts: 'Snelnavigatie',
  },
  ok: 'Oké',
  optionalInput: '(optioneel)',
  or: 'of',
  pagination: {
    label: 'Paginanavigatie',
    next: 'Volgende pagina',
    pageSize: 'Aantal resultaten per pagina',
    previous: 'Vorige pagina',
  },
  pdfPreview: {
    download: 'Pdf downloaden',
    fallback: 'Je browser kan deze pdf niet weergeven.',
  },
  placeholders: {
    file: 'Kies je bestand',
    select: 'Selecteer',
  },
  richText: {
    errors: {
      render: 'Er ging iets mis bij het laden van de inhoud.',
    },
    linkModal: {
      editTitle: 'Pas de link aan',
      label: 'Link',
      textLabel: 'Tekst',
      title: 'Vul een link in',
    },
    toolbar: {
      bold: 'Vet',
      bulletList: 'Opsommingslijst',
      editLink: 'Link aanpassen',
      groups: {
        formatting: 'Tekstopmaak',
        history: 'Geschiedenis',
        lists: 'Opsommingen',
        shortcodes: 'Shortcode toevoegen',
      },
      italic: 'Cursief',
      link: 'Link toevoegen',
      orderedList: 'Genummerde lijst',
      redo: 'Opnieuw uitvoeren',
      shortcodes: 'Shortcode toevoegen',
      underline: 'Onderstrepen',
      undo: 'Ongedaan maken',
      unlink: 'Link verwijderen',
    },
  },
  save: 'Opslaan',
  saved: 'Opgeslagen',
  send: 'Versturen',
  sidebar: {
    clients: 'Klanten',
    community: 'Netwerk',
    dashboard: 'Dashboard',
    expandMenu: 'Menu uitklappen',
    forum: 'Forum',
    groupInvoicing: 'Facturatie',
    groupSocial: 'Community',
    help: 'Help',
    invite: 'Vrienden uitnodigen',
    invoices: 'Facturen',
    jobPosts: 'Opdrachten',
    minimalizeMenu: 'Menu inklappen',
    more: 'Meer',
    products: 'Producten',
    quotations: 'Offertes',
  },
  status: {
    completed: 'Voltooid',
    upcoming: 'Nog te doen',
  },
  timeline: {
    ariaLabel: 'Tijdslijn',
  },
  topbar: {
    activePremiumForFree_one: 'Allerlaatste dag gratis factureren',
    activePremiumForFree_other: 'Nog {{count}} dagen gratis factureren',
    dropdown: {
      commission: 'Je vergoeding',
      documents: 'Documenten',
      invitations: 'Uitnodigingen',
      logout: 'Uitloggen',
      settings: 'Instellingen',
    },
  },
};
